import { graphql, useStaticQuery } from 'gatsby';

import { QueryFragments } from './queryFragments'; // eslint-disable-line

export const useNavQuery = () => {
  const { sanitySettingsNav } = useStaticQuery(graphql`
    query {
      sanitySettingsNav {
        mainMenu {
          page {
            ...PageRef
          }
          maoriLinkText
          linkText
          _type
        }
        sideMenu {
          linkText
          page {
            ...PageRef
          }
        }
        contactInfo: _rawContactInfo(resolveReferences: { maxDepth: 10 })
      }
    }
  `);
  return sanitySettingsNav || {};
};
